export default __webpack_public_path__ + "static/media/HeatExchangersImg.62c574eb.jpg";